export class FullImage {

    private imageContainer: HTMLElement;
    private isOpen: boolean;

    constructor(imageId) {
        this.initImage(imageId);
    }

    private initImage(imageId: string): void {
        this.imageContainer = document.getElementById(imageId);
        if (this.imageContainer) {
            this.imageContainer.children[0].addEventListener('click', () => !this.isOpen && this.openImage());

            const exitElement = document.createElement('div');
            exitElement.className = 'exit';
            exitElement.innerHTML = '<svg class="exit__icon" viewBox="0 0 24 24"><use xlink:href="/images/icons.svg#exit"></use></svg>';
            exitElement.addEventListener('click', () => this.closeImage());
            this.imageContainer.appendChild(exitElement);         
        }  
    }

    private openImage(): void {
        this.imageContainer.classList.add('full');
        this.isOpen = true;
    }

    private closeImage(): void {
        this.imageContainer.classList.remove('full');
        this.isOpen = false;
    }

}